import React, { useState } from 'react';

const skillData = {
  Cloud: [
    { name: 'AWS', icon: '/logos/aws.svg' },
    { name: 'GCP', icon: '/logos/google-cloud.svg' },
    { name: 'DigitalOcean', icon: '/logos/digitalocean.svg' },
  ],
  'CI/CD': [
    { name: 'GitLab CI/CD', icon: '/logos/gitlab.png' },
    { name: 'GitHub Actions', icon: '/logos/github.webp' },
    { name: 'Jenkins', icon: '/logos/jenkins.svg' },
    { name: 'ArgoCD', icon: '/logos/argocd.webp' },
    { name: 'AWS CodePipeline', icon: '/logos/awscode.webp' },
  ],
  Infrastructure: [
    { name: 'Terraform', icon: '/logos/terraform.png' },
    { name: 'Ansible', icon: '/logos/ansible.svg' },
    { name: 'Helm', icon: '/logos/helm.webp' },
  ],
  Containers: [
    { name: 'Docker', icon: '/logos/docker.png' },
    { name: 'Kubernetes', icon: '/logos/k8s.svg' },
    { name: 'EKS', icon: '/logos/eks.webp' },
  ],
  Monitoring: [
    { name: 'Prometheus', icon: '/logos/prometheus.svg' },
    { name: 'Grafana', icon: '/logos/grafana.svg' },
    { name: 'Loki', icon: '/logos/loki1.png' },
    { name: 'Elasticsearch', icon: '/logos/elasticsearch.svg' },
    { name: 'New Relic', icon: '/logos/newrelic.svg' },
    { name: 'Datadog', icon: '/logos/DataDog.webp' },
    { name: 'MMonit', icon: '/logos/Mmonit.webp' },
  ],
  Security: [
    { name: 'Trivy', icon: '/logos/trivy.webp' },
    { name: 'Snyk', icon: '/logos/snyk.webp' },
    { name: 'SonarQube', icon: '/logos/sonarqube.webp' },
    { name: 'OpenVPN', icon: '/logos/openvpn.webp' },
  ],
  Databases: [
    { name: 'MySQL', icon: '/logos/mysql.svg' },
    { name: 'PostgreSQL', icon: '/logos/postgresql.svg' },
    { name: 'Redis', icon: '/logos/redis.svg' },
    { name: 'RabbitMQ', icon: '/logos/rabbitmq.svg' },
  ],
  OS: [
    { name: 'Linux', icon: '/logos/linux.svg' },
    { name: 'Ubuntu', icon: '/logos/ubuntu.svg' },
    { name: 'Debian', icon: '/logos/debian.svg' },
  ],
  'Programming Languages': [
    { name: 'Python', icon: '/logos/python.svg' },
    { name: 'Shell Scripting', icon: '/logos/Bash.png' },
  ],
};

function Skills() {
  const [category, setCategory] = useState('Cloud');
  const categories = Object.keys(skillData);

  return (
    <section id="skills" className="bg-slate-900 text-white px-6 py-16 scroll-mt-28">
      <h2 className="text-3xl font-bold text-center mb-8">Skills & Tools</h2>

      {/* Filter buttons */}
      <div className="flex justify-center flex-wrap gap-4 mb-10">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`px-4 py-1 rounded-md text-sm font-semibold ${
              cat === category ? 'bg-blue-600 text-white' : 'bg-slate-700 text-gray-300 hover:bg-blue-500'
            }`}
            onClick={() => setCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Skills grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
        {skillData[category].map((skill, idx) => (
          <div
            key={idx}
            className="bg-slate-800 rounded-lg p-4 flex flex-col items-center shadow hover:shadow-lg transition"
          >
            <img
              src={skill.icon}
              alt={skill.name}
              className="w-12 h-12 object-contain mb-3"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/logos/placeholder.svg'; // fallback
              }}
            />
            <p className="text-center text-sm">{skill.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
